import PasswordRecoverySetPasswordPageContainer from "./PasswordRecoverySetPasswordPageContainer";

export default PasswordRecoverySetPasswordPageContainer;
